/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { fetchSnapshots } from '@/actions/snapshots'
import { fetchSnapshotsRequest } from '@/reducers/asyncRequests/registry'
import { getClusterSnapshots } from '@/reducers/clusterSnapshots'

import withPolling from '../../../../lib/withPolling'

import SnapshotHistory from './SnapshotHistory'
import { StateProps, DispatchProps, ConsumerProps } from './types'

import type { ReduxState, ThunkDispatch } from '@/types/redux'

const mapStateToProps = (state: ReduxState, { deployment }): StateProps => ({
  snapshots: getClusterSnapshots(state, deployment.id),
  fetchSnapshotsRequest: fetchSnapshotsRequest(state, deployment.id),
})

const mapDispatchToProps = (dispatch: ThunkDispatch, { deployment }) => ({
  fetchSnapshots: () => dispatch(fetchSnapshots({ deployment })),
})

const PollingSnapshotHistory = withPolling(SnapshotHistory, ({ fetchSnapshots: onPoll }) => ({
  onPoll,
}))

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(PollingSnapshotHistory)
